import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Footer.css';
import { loadSiteTitle } from './Header';

function Footer() {
  const { t } = useTranslation();
  // 設定画面の「予約サイトのタイトル」があれば、© の後ろをそれにする（年は今年）
  const [siteTitle, setSiteTitle] = useState('');
  useEffect(() => { void loadSiteTitle().then(setSiteTitle); }, []);

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <p className="copyright">{siteTitle ? `© ${new Date().getFullYear()} ${siteTitle}` : t('footer.copyright')}</p>
          <div className="footer-links">
            <Link to="/terms">{t('footer.terms')}</Link>
            <Link to="/privacy">{t('footer.privacy')}</Link>
            <Link to="/tokushoho">{t('footer.tokushoho')}</Link>
            <Link to="/contact">{t('footer.contact')}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
